import React from "react";
import inviteImage from "~/images/invite_or_find_illustration.png";

const OnboardingFormWrapper = ({ title, actionButtons, image = inviteImage, children }) => {
  return (
    <div className="onboarding__container">
      <div className="onboarding__logo" />

      <div className="onboarding__bg__container">
        <div className="onboarding__bg__light onboarding__bg__light--fullwidth" />
      </div>

      <div className="onboarding__content onboarding__content--centered">
        <div className="onboarding__content__body">
          <div className="onboarding__content__form">
            <div className="onboarding__content__form__image">
              <img src={image} />
            </div>
            <div className="onboarding__content__form__title">{title}</div>
            {children}
            <div className="onboarding__actions">{actionButtons}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingFormWrapper;
